import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DetalheBaseController } from '../../../helpers';
import { DevedorService } from '../../../services';
import { APPCONFIG } from '../../../config';

@Component({
    templateUrl: 'confirmWizard.edit.component.html',
})

export class ConfirmWizardEditComponent extends DetalheBaseController {
    constructor(route: ActivatedRoute, private router: Router, private _devedorService: DevedorService) {
        super(route, _devedorService);  
    }

    AppConfig;

    ngOnInit() {
        this.AppConfig = APPCONFIG;
    }

    Finalizar() {        
        location.href = this.AppConfig.urlS5;                        
    }       
    
    ngOnDestroy() {
    }
}



// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/components/confirm/edit/confirmWizard.edit.component.ts